<template>
  <div>
    <BaseTitle :title="$t('menu.quiz')" :yearPeriode="titleData" />

    <v-progress-circular class="text-center" v-if="loading === true" indeterminate color="primary"></v-progress-circular>
    <v-btn v-if="this.countDown !== 'null'" v-scroll="onScroll" v-show="fab" fab fixed large top rounded right color="primary">
      <span>{{ minuteSecond }}</span></v-btn
    >
    <div>
      <div class="succ" v-if="this.countDown !== 'null'">
        <div class="succ-content">
          <v-card class="succ">
            <div class="pa-4">
              <svg-icon icon="clock" class="primary--text mr-4" />
              <span>{{ $t('content.time_remaining') }} : {{ minuteSecond }}</span>
            </div>
          </v-card>
        </div>
      </div>
      <v-card class="mb-5" v-for="lists in quizList.quizQuestions" v-bind:key="lists.quizQuestionId">
        <template>
          <div class="pa-5 d-flex justiy-space-between align-items section-header active">
            <div class="student-title">{{ $t('question.question') }} {{ lists.quizQuestionNo }}</div>
            <v-spacer />
            <div class="student-title">{{ $t('menu.score') }}: {{ lists.score }}</div>
          </div>
        </template>
        <template>
          <div class="assignment-content">
            <div class="mt-6">
              <article class="container" v-html="lists.quizQuestion" />
              <img
                :src="lists.imageUrl"
                style="
                      width : 50%;
                      height : 30%;
                      flex: 1;
                    "
                class="mb-5"
              />
            </div>
            <v-divider />
            <div class="ml-3" v-if="lists.quizTypeId === 1">
              <div class="mt-2 mb-2 pa-5" v-if="loadingSoal === true">
                <span>{{ $t('content.please_wait') }}</span>
              </div>
              <v-radio-group v-if="loadingSoal === false" v-model="lists.quizOther">
                <v-radio
                  :disabled="loadingSoal"
                  class="pa-2 compact-form"
                  v-for="radio in lists.quizAnswers"
                  :key="radio.quizAnswerId"
                  :label="radio.answer"
                  :value="radio.quizAnswerId"
                  color="info"
                  @change="TemporarySubmit"
                />
              </v-radio-group>
            </div>
            <div class="ml-3" v-if="lists.quizTypeId === 2">
              <div class="mt-2 mb-2 pa-5" v-if="loadingSoal === true">
                <span>{{ $t('content.please_wait') }}</span>
              </div>
              <template v-if="loadingSoal === false">
                <v-checkbox
                  :disabled="loadingSoal"
                  color="info"
                  class="compact-form"
                  v-for="radio in lists.quizAnswers"
                  :key="radio.quizAnswerId"
                  v-model="lists.quizMultiple"
                  :label="radio.answer"
                  :value="radio.quizAnswerId"
                  @change="TemporarySubmit"
                />
              </template>
            </div>
            <div class="ml-3" v-if="lists.quizTypeId === 3">
              <div class="mt-2 mb-2 pa-5" v-if="loadingSoal === true">
                <span>{{ $t('content.please_wait') }}</span>
              </div>
              <div class="compact-form pa-3">
                <text-editor :disabled="loadingSoal" v-model="lists.quizOther" @change="TemporarySubmit" />
              </div>
            </div>
            <div class="ml-3" v-if="lists.quizTypeId === 4">
              <div class="mt-2 mb-2 pa-5" v-if="loadingSoal === true">
                <span>{{ $t('content.please_wait') }}</span>
              </div>
              <template v-if="loadingSoal === false">
                <v-text-field
                  :disabled="loadingSoal"
                  class="compact-form"
                  v-for="radio in lists.quizAnswers"
                  v-bind:key="radio.quizAnswerId"
                  v-model="radio.quizAnswer"
                  @change="TemporarySubmit"
                  :label="$t('content.your_answer')"
                />
              </template>
            </div>
            <div class="ml-3" v-if="lists.quizTypeId === 5">
              <div class="mt-2 mb-2 pa-5" v-if="loadingSoal === true">
                <span>{{ $t('content.please_wait') }}</span>
              </div>
              <template v-if="loadingSoal === false">
                <v-text-field
                  :disabled="loadingSoal"
                  @keypress="isNumber($event)"
                  @paste="onPaste"
                  @change="TemporarySubmit"
                  v-model="lists.quizOther"
                  class="compact-form"
                  :label="$t('content.your_answer')"
                />
              </template>
            </div>
          </div>
        </template>
      </v-card>
      <!-- Dialog submit -->
      <v-dialog v-model="submitData" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">{{ $t('content.filled_quiz_title') }} ?</v-card-title>
          <v-card-text>{{ $t('content.filled_quiz_content') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="submitData = false">{{ $t('disagree') }}</v-btn>
            <v-btn text :loading="loadingSoal" @click="submit">{{ $t('aggree') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog Back -->
      <v-dialog v-model="dialogBack" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">{{ $t('content.warning') }} !!</v-card-title>
          <v-card-text>{{ $t('content.quit') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogBack = false">{{ $t('disagree') }}</v-btn>
            <v-btn text @click="back">{{ $t('aggree') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="d-flex justify-end align-center">
        <v-btn color="primary" class="btn-primary-custom mr-3" :disabled="loadingSoal" outlined @click="dialogBack = true">{{ $t('back') }}</v-btn>
        <v-btn color="primary" :loading="loadingSoal" class="btn-primary-custom" @click="submitData = true" type="submit">{{ $t('submit') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import TextEditor from '@/components/base/TextEditor.vue';

export default {
  name: 'StudentAssignmentScoreQuiz',
  components: {
    BaseTitle,
    TextEditor
  },
  computed: {
    ...mapGetters({ user: 'Auth/user', tokenBearer: 'Auth/token', nameCourse: 'CourseList/nameCourse' }),
    minuteSecond() {
      function format(time) {
        // Hours, minutes and seconds
        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = ~~time % 60;

        // Output like "1:01" or "4:03:59" or "123:03:59"
        var ret = '';
        if (hrs > 0) {
          ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
        }
        if (mins > 0) {
          ret += '' + mins + ':' + (secs < 10 ? '0' : '');
        }
        ret += '' + secs;
        return ret;
      }

      if (this.countDown) {
        return format(this.countDown);
      } else {
        return null;
      }

      // return new Date(this.countDown * 1000).toISOString().substr(11, 8);
    }
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateDetailAssignment({ classId, courseId, assignmentId }) {
      const { classId: currentClassId, courseId: currentCourseId, assignmentId: currentAssignmentId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId && assignmentId == currentAssignmentId) {
        this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.list_assignment') });
        setTimeout(() => {
          var assignmentId = this.$route.params.assignmentId;
          this.quizList.quizQuestions.forEach(form => {
            if (form.quizTypeId === 1) {
              (form.quizAnswers = [form.quizOther.toString()]), (form.assignmentId = assignmentId);
            } else if (form.quizTypeId === 2) {
              (form.quizAnswers = form.quizMultiple), (form.assignmentId = assignmentId);
            } else if (form.quizTypeId === 3) {
              (form.quizAnswers = [form.quizOther.toString()]), (form.assignmentId = assignmentId);
            } else if (form.quizTypeId === 4) {
              let dataQuiz = form.quizAnswers.reduce((acc, row) => {
                acc.push(row.quizAnswer);
                return acc;
              }, []);
              (form.quizAnswers = dataQuiz), (form.assignmentId = assignmentId);
            } else if (form.quizTypeId === 5) {
              (form.quizAnswers = [form.quizOther.toString()]), (form.assignmentId = assignmentId);
            }
          });
          var json = {
            answers: this.quizList.quizQuestions
          };
          this.loading = true;
          this.edit = true;
          this.$store
            .dispatch('Assignment/submitQuizStudent', json)
            .then(() => {
              clearTimeout(this.timer);
              localStorage.removeItem('timeQuiz');
              this.$router.push({
                name:
                  localStorage.getItem('backModules', true) && !this.$route.params.classSectionId
                    ? 'StudentAssignmentScoreQuizSuccessModules'
                    : !localStorage.getItem('backModules', true) && !this.$route.params.classSectionId
                    ? 'StudentAssignmentScoreQuizSuccess'
                    : localStorage.getItem('backModules', true) && this.$route.params.classSectionId
                    ? 'StudentSectionAssignmentScoreQuizSuccessModules'
                    : 'StudentSectionAssignmentScoreQuizSuccess'
              });
            })
            .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
            .finally(() => (this.loading = false));
        }, 400);
      }
    }
  },
  data: () => ({
    dialogBack: false,
    submitData: false,
    loading: false,
    checkbox: false,
    radioGroup: '',
    description: '',
    dataClass: '',
    answer: '',
    countDown: localStorage.getItem('timeQuiz'),
    baseUrl: process.env.VUE_APP_BASE_URL,
    quizList: '',
    fab: false,
    edit: false,
    timer: '',
    loadingSoal: false,
    checkData: '',
    resData: '',
    emptyData: '',
    titleData: ''
  }),
  // watch: {
  //   countDown: {
  //     handler(value) {
  //       if (value > 0) {
  //         setTimeout(() => {
  //           this.countDown--;
  //           localStorage.setItem('timeQuiz', this.countDown);
  //         }, 1000);
  //       } else if (value === 0) {
  //         this.submit();
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    onPaste(evt) {
      if (evt) {
        evt.preventDefault();
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45 && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    getData() {
      if (isNaN(this.countDown)) {
        this.countDown = 'null';
      }
      setTimeout(() => {
        var assignmentId = this.$route.params.assignmentId;
        if (this.loadingSoal === false) {
          this.loading = true;
        }
        this.$store
          .dispatch('Assignment/fetchQuizTemporary', { assignmentId, id: this.user.userId })
          .then(data => {
            function isEmpty(obj) {
              return Object.keys(obj).length === 0;
            }
            this.checkData = data;
            this.emptyData = isEmpty(data);
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => {
            var data = this.checkData;
            setTimeout(() => {
              if (this.emptyData === false) {
                this.$store
                  .dispatch('Assignment/fectQuiz', { assignmentId })
                  .then(res => {
                    this.resData = res;
                  })
                  .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
                  .finally(() => {
                    var res = this.resData;
                    for (let index = 0; index < res.quizQuestions.length; index++) {
                      res.quizQuestions[index].quizMultiple = [];
                      res.quizQuestions[index].quizOther = '';
                      res.quizQuestions[index].quizAnswers.forEach(form => {
                        form.quizAnswer = '';
                      });
                    }
                    const iterator = data.answers.keys();

                    for (const key of iterator) {
                      var keydata = data.answers[key].quizQuestionNo;
                      if (res.quizQuestions[key].quizTypeId === 1) {
                        if (parseInt(data.answers[key].quizAnswers[0])) {
                          res.quizQuestions[keydata - 1].quizOther = parseInt(data.answers[key].quizAnswers[0]);
                        } else {
                          res.quizQuestions[keydata - 1].quizOther = '';
                        }
                      } else if (res.quizQuestions[keydata - 1].quizTypeId === 2) {
                        var arraymulti = data.answers[key].quizAnswers.map(Number);
                        for (var i = 0; i < arraymulti.length; i++) {
                          if (arraymulti[i] == '0') arraymulti.splice(i, 1);
                        }
                        res.quizQuestions[keydata - 1].quizMultiple = arraymulti;
                      } else if (res.quizQuestions[key].quizTypeId === 3) {
                        res.quizQuestions[key].quizOther = data.answers[key].quizAnswers[0];
                      } else if (res.quizQuestions[key].quizTypeId === 5) {
                        res.quizQuestions[key].quizOther = data.answers[key].quizAnswers[0];
                      }
                    }

                    let satu = res.quizQuestions;
                    let dua = data.answers;
                    for (let idx = 0; idx < satu.length; idx++) {
                      let el1 = satu[idx];
                      for (let id1 = 0; id1 < dua.length; id1++) {
                        let el2 = dua[id1];
                        if (el1.quizQuestionId === el2.quizQuestionId && el1.quizTypeId === 4) {
                          var string = el1.quizQuestion;
                          var number = 0;

                          el1.quizQuestion = string.replaceAll('(?)', function() {
                            return '(' + ++number + ')';
                          });
                          el1.quizQuestionNo = el2.quizQuestionNo;
                          for (let idb = 0; idb < el1.quizAnswers.length; idb++) {
                            let el1_1 = el1.quizAnswers[idb];
                            for (let idc = 0; idc < el2.quizAnswers.length; idc++) {
                              let el2_2 = el2.quizAnswers[idc];
                              if (el1_1.quizQuestionId === el2.quizQuestionId && idb === idc) {
                                el1_1.quizAnswer = el2_2;
                              }
                            }
                          }
                        }
                      }
                    }

                    if (data.timeLeft) {
                      this.countDown = data.timeLeft;
                    } else {
                      this.countDown = 'null';
                    }
                    this.quizList = res;

                    this.loadingSoal = false;
                  });
              } else {
                this.$store
                  .dispatch('Assignment/fectQuiz', { assignmentId })
                  .then(res => {
                    this.resData = res;
                  })
                  .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
                  .finally(() => {
                    var res = this.resData;
                    res.quizQuestions.forEach(form => {
                      form.quizMultiple = [];
                      form.quizOther = '';
                      if (form.quizTypeId === 4) {
                        var string = form.quizQuestion;
                        var number = 0;

                        form.quizQuestion = string.replaceAll('(?)', function() {
                          return '(' + ++number + ')';
                        });
                        form.quizAnswers.forEach(quiz => (quiz.quizAnswer = ''));
                      }
                    });
                    this.quizList = res;
                    this.loadingSoal = false;
                  });
              }
            }, 30);
            this.loading = false;
          });
      }, 30);
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    TemporarySubmit() {
      if (isNaN(this.countDown)) {
        this.countDown = 'null';
      }
      clearTimeout(this.timer);
      setTimeout(() => {
        if (isNaN(this.countDown)) {
          this.countDown = 'null';
        } else {
          this.countDown = this.countDown - 1;
        }
        var assignmentId = this.$route.params.assignmentId;
        var json = {
          assignmentId: assignmentId,
          userId: this.user.userId,
          timeLeft: this.countDown,
          lastAnswerSubmitted: moment().format('YYYY-MM-DD HH:mm'),
          answers: this.quizList.quizQuestions
        };

        this.loadingSoal = true;
        this.$store
          .dispatch('Assignment/submitQuizStudentTemporary', json)
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .then(() => {})
          .finally(() => {
            this.getData();
            if (this.countDown > 0) {
              this.countDownTimer();
            }
          });
      }, 30);
    },
    submit() {
      this.loadingSoal = true;
      var assignmentId = this.$route.params.assignmentId;
      this.quizList.quizQuestions.forEach(form => {
        if (form.quizTypeId === 1) {
          (form.quizAnswers = [form.quizOther.toString()]), (form.assignmentId = assignmentId);
        } else if (form.quizTypeId === 2) {
          (form.quizAnswers = form.quizMultiple), (form.assignmentId = assignmentId);
        } else if (form.quizTypeId === 3) {
          (form.quizAnswers = [form.quizOther.toString()]), (form.assignmentId = assignmentId);
        } else if (form.quizTypeId === 4) {
          let dataQuiz = form.quizAnswers.reduce((acc, row) => {
            acc.push(row.quizAnswer);
            return acc;
          }, []);
          (form.quizAnswers = dataQuiz), (form.assignmentId = assignmentId);
        } else if (form.quizTypeId === 5) {
          (form.quizAnswers = [form.quizOther.toString()]), (form.assignmentId = assignmentId);
        }
      });
      var json = {
        answers: this.quizList.quizQuestions
      };
      this.edit = true;
      this.$store
        .dispatch('Assignment/submitQuizStudent', json)
        .then(() => {
          clearTimeout(this.timer);
          localStorage.removeItem('timeQuiz');
          if (localStorage.getItem('backModules', true)) {
            localStorage.removeItem('backModules');
            this.$router.push({
              name: 'StudentAssignmentScoreQuizSuccessModules'
            });
          } else {
            localStorage.removeItem('backModules');
            this.$router.push({
              name: 'StudentAssignmentScoreQuizSuccess'
            });
          }
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          // if ((this.loading = true)) {
          this.loading = false;

          this.loadingSoal = false;
        });
    },
    back() {
      clearTimeout(this.timer);
      this.edit = true;
      this.TemporarySubmit();
      this.$router.push({ name: 'StudentAssignmentDetail' });
    },
    countDownTimer() {
      if (this.countDown >= 1) {
        this.timer = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.loading = true;
        clearTimeout(this.timer);
        this.submit();
      }
    }
  },
  created() {
    if (this.countDown > 0) {
      this.countDownTimer();
    }
    this.getData();
    this.getDataClass();
  },
  beforeMount() {
    window.addEventListener('beforeunload', function(e) {
      e.preventDefault();
      e.returnValue = '';
    });
    this.$once('hook:beforeDestroy', () =>
      window.removeEventListener('beforeunload', function(e) {
        e.preventDefault();
        e.returnValue = '';
      })
    );
  },
  beforeRouteLeave(to, from, next) {
    if (this.edit === false) {
      var is_sure = window.confirm(this.$t('content.quit'));
      if (is_sure) {
        clearTimeout(this.timer);
        this.TemporarySubmit();
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
};
</script>

<style lang="scss" scoped>
.compact-form {
  transform: scale(0.875);
  transform-origin: left;
}
.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    font-size: 12px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;
  }
}
.assignment {
  &-title {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #acacac;
  }

  &-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    box-sizing: border-box;
    text-align: center;
    margin-right: 16px;

    svg {
      transform: scale(1.6);
      margin-top: 15px;
    }
  }

  &-content {
    margin: 10px 20px 20px 20px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
    font-family: Montserrat;
    line-height: 20px;
    text-align: left;
  }
  &-desc {
    line-height: 1.8em;
    padding-left: 65px;
  }
}

.section-header {
  border-radius: 8px 8px 0px 0px;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
